/**
 * mco-mwmo-fixes.js
 * Single-open FAQ accordion behavior for /pages/made-with-mocap-online.
 * Kingdom's <toggle-tab> elements toggle independently by default; this script
 * watches for the "opened" class on any toggle-tab inside the FAQ section and,
 * when one opens, closes all the others in the same container by clicking
 * their titles (the click handler on the title is what Kingdom uses to
 * toggle state, so this is the safest cross-version interaction).
 *
 * Loaded via theme.liquid include gated on /pages/made-with-mocap-online.
 */
(function () {
  'use strict';

  if (!/\/pages\/made-with-mocap-online/i.test(location.pathname)) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var faqSection = document.querySelector('.shopify-section.faq');
    if (!faqSection) return;

    var tabs = faqSection.querySelectorAll('toggle-tab');
    if (!tabs.length) return;

    var isClosingPeers = false;

    var observer = new MutationObserver(function (mutations) {
      if (isClosingPeers) return;
      mutations.forEach(function (m) {
        if (m.type !== 'attributes' || m.attributeName !== 'class') return;
        var target = m.target;
        if (target.tagName !== 'TOGGLE-TAB') return;
        if (!target.classList.contains('opened')) return;

        // Close all other toggle-tabs in the same FAQ section
        isClosingPeers = true;
        try {
          tabs.forEach(function (other) {
            if (other === target) return;
            if (!other.classList.contains('opened')) return;
            var title = other.querySelector('.toggle__title');
            if (title) title.click();
          });
        } finally {
          isClosingPeers = false;
        }
      });
    });

    tabs.forEach(function (t) {
      observer.observe(t, { attributes: true, attributeFilter: ['class'] });
    });
  }
})();
